// Modal tạo/sửa 1 nhiệm vụ. Tạo mới chỉ có loại "xem màn hình"; sửa thì không đổi loại. Mô tả thay đổi theo loại.
import { useState } from "react";
import { Alert, Input, Modal, Select, Switch } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Field, NumField } from "./xu-config-fields";
import XuGoldenHoursEditor from "./xu-golden-hours-editor";
import { MISSION_ICON_MAP } from "./xu-mission-icon-options";
import { missionError, newMissionKey, screenConflict } from "./xu-mission-validate";

const blank = (meta, missions) => {
    const used = new Set(Object.values(missions).filter((x) => x.enabled && x.type === "view_screen").map((x) => x.screen));
    const screen = (meta.screens.find((s) => !used.has(s.value)) || meta.screens[0]).value;
    const order = Math.max(0, ...Object.values(missions).map((x) => x.order || 0)) + 1;
    return { type: "view_screen", screen, seconds: 30, title: "", description: "", icon: "star", reward: 50, order, enabled: true };
};

/** `editKey` null = tạo mới. Nội dung form giữ trong state nội bộ, chỉ đẩy lên khi bấm Lưu. */
export default function XuMissionEditModal({ editKey, missions, meta, onOk, onCancel }) {
    const [m, setM] = useState(() => (editKey ? { ...missions[editKey] } : blank(meta, missions)));
    const [shown, setShown] = useState(false);
    const patch = (p) => setM((prev) => ({ ...prev, ...p }));
    const err = missionError(m, meta) || (() => {
        const t = screenConflict(missions, editKey, m);
        return t ? `Màn này đang có nhiệm vụ “${t}” bật. Hãy tắt nhiệm vụ đó trước, hoặc chọn màn khác.` : null;
    })();
    const submit = () => {
        if (err) return setShown(true);
        onOk(editKey || newMissionKey(m.screen), { ...m, title: m.title.trim() });
    };
    return (
        <Modal open title={editKey ? "Sửa nhiệm vụ" : "Thêm nhiệm vụ xem màn hình"} width={560} okText="Xong" cancelText="Huỷ" onOk={submit} onCancel={onCancel} destroyOnClose>
            <p className="text-gray-500 text-sm mb-3">Bấm “Xong” rồi nhớ bấm “Lưu cấu hình” ở cuối trang thì thay đổi mới có hiệu lực.</p>
            {m.type === "view_screen" && (
                <div className="flex gap-4 flex-wrap">
                    <Field label="Màn hình cần xem" hint="Người dùng phải ở lại màn này đủ số giây.">
                        <Select value={m.screen} style={{ width: 180 }} options={meta.screens} disabled={Boolean(editKey)} onChange={(v) => patch({ screen: v })} />
                    </Field>
                    <NumField label="Số giây phải xem" unit="giây" min={meta.secondsRange[0]} max={meta.secondsRange[1]} value={m.seconds} onChange={(v) => patch({ seconds: v })}
                        hint={`Từ ${meta.secondsRange[0]} đến ${meta.secondsRange[1]} giây.`} />
                </div>
            )}
            {m.type === "buy_now" && (
                <Field label="Khung giờ vàng (giờ Việt Nam)" hint="Tạo link mua hàng trong các khung này mới tính là xong nhiệm vụ.">
                    <XuGoldenHoursEditor value={m.goldenHours} onChange={(v) => patch({ goldenHours: v })} />
                </Field>
            )}
            {m.type === "order_app" && (
                <NumField label="Chỉ tính đơn phát sinh trong vòng" unit="giờ" min={1} max={720} value={m.maxOrderAgeHours} onChange={(v) => patch({ maxOrderAgeHours: v })}
                    hint="Đơn cũ hơn không được tính. Đơn về sau vài giờ đến 1 ngày thì Xu tự cộng, người dùng không cần bấm “Nhận”." example="72 giờ = 3 ngày" />
            )}
            <Field label="Tên hiển thị" hint="Người dùng thấy tên này trong app.">
                <Input value={m.title} maxLength={meta.titleMax} showCount placeholder="Ví dụ: Xem cộng đồng" onChange={(e) => patch({ title: e.target.value })} />
            </Field>
            <Field label="Mô tả ngắn (tuỳ chọn)" hint="Để trống thì app dùng câu mặc định.">
                <Input.TextArea value={m.description} rows={2} maxLength={meta.descriptionMax} showCount onChange={(e) => patch({ description: e.target.value })} />
            </Field>
            <Field label="Biểu tượng">
                <div className="flex flex-wrap gap-2">
                    {meta.icons.map((n) => (
                        <button type="button" key={n} onClick={() => patch({ icon: n })}
                            className={`w-9 h-9 rounded-lg border flex items-center justify-center ${m.icon === n ? "border-indigo-500 bg-indigo-50 text-indigo-600" : "text-gray-500"}`}>
                            <FontAwesomeIcon icon={MISSION_ICON_MAP[n]} />
                        </button>
                    ))}
                </div>
            </Field>
            <div className="flex gap-6 items-end">
                <NumField label="Thưởng" unit="Xu" value={m.reward} max={100000} onChange={(v) => patch({ reward: v })} className="mb-0" />
                <Field label="Đang bật" className="mb-0"><Switch checked={m.enabled} onChange={(v) => patch({ enabled: v })} /></Field>
            </div>
            {shown && err && <Alert className="mt-3" type="error" showIcon message={err} />}
        </Modal>
    );
}
